define('models/StoreModel',[
    'require',
    'underscore',
    'ObjectModel',
    'LocalStorage',
    'UrlFactory',
    'app',
    'StringSimplification',
    'string',
    'moment',
    'moment-round',
    'ApiRequest',
    'models/StoreMessageCollection',
    'models/ProductModel',
    'models/PaymentMethodCollection',
    'models/PaymentGroupCollection',
    'models/PaymentGroupModel',
    'models/PaymentModeModel',
    'models/StockoutProductModel',
    'models/StoreAvisVerifieModel',
], function (
    require,
    _,
    ObjectModel,
    LocalStorage,
    UrlFactory,
    app,
    Simplification,
    S,
    moment,
    momentRound,
    ApiRequest,
    StoreMessageCollection,
    ProductModel,
    PaymentMethodCollection,
    PaymentGroupCollection,
    PaymentGroupModel,
    PaymentModeModel,
    StockoutProductModel,
    StoreAvisVerifieModel
) {
    //
    // Model Store
    //

    var _TRANSLATION_CONTEXT_STORES_ = 'Stores',
        _MIN_DIFFER_DELAY_ = 45; // délai minimum en différé par défaut, en minutes, par rapport à maintenant;

    function PadSeconds(hhmm) {
        hhmm = hhmm ? hhmm : '00:00'; // exception, si les données sont invalides, on gère un cas par défaut
        return S(hhmm).padRight(6, ':').padRight(8, '0').s;
    }

    function isBeforeNow(d) {
        return moment(d).diff() < 0;
    }

    function minDifferDelay() {
        // délai minimum en différé, en ms, par rapport à maintenant;
        return (
            parseInt(app.c('_MIN_DIFFER_DELAY_', _MIN_DIFFER_DELAY_)) * 60000
        );
    }

    var StoreModelPrototype = {
        name: 'StoreModel',
        idAttribute: 'id_store',
        route: 'apiStoreModel',
        remoteCache: 'no-cache',

        defaults: {
            name: '',
            active: true,
            comming_soon: false,
            sale_on_web: true,
            accept_shipping: true,
            accept_vae: true,
            template: 'single-store',
            type_shop: 0,
            google_cid: false,
            breadcrumb: [],
            benefit: {
                primary: [],
                secondary: [],
            },
            closure: {
                closed: false,
            },
        },

        initialize: function () {
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);

            //
            if (!this.get(this.idAttribute)) {
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        /*getTemplate:function(){
                var template = this.get('template');
                if(template == 'travel-retail'){
                    template = 'corner';
                }
               return require('template!blocks/stores/corner'+template)
            },*/
        hasModifiers: function () {
            return !_.isUndefined(this.get('modifiers'));
        },

        getProductPrice: function (product, type) {
            var productModifier = this.getProduct(product);

            if (productModifier) {
                var productModifierPrice = parseFloat(
                    productModifier['price_' + type]
                );
                if (productModifierPrice >= 0) {
                    return productModifierPrice;
                }
            }

            return product.getPrice(type, false);
        },
        getProduct: function (product) {
            var productModifier,
                store = this,
                id_product = _.isString(product) ? product : product.id,
                modifiers = store.get('modifiers');
            if (modifiers) {
                productModifier = _(modifiers.products).find({
                    id_product: id_product,
                });
                if (productModifier) {
                    productModifier.isStockout = store
                        .getStockoutProduct()
                        .isStockout(id_product);
                }
            }
            return productModifier;
        },

        getName: function () {
            return this.get('name');
        },
        getFullName: function () {
            // nom du shop avec Sushi Shop devant (ou sa variante localisée)
            return app.getShopName() + ' ' + this.getName();
        },
        getTypeName: function (plural) {
            var shopName = app.getShopName(),
                type = this.get('type_shop'),
                typeName = shopName;
            if (type > 0) {
                // si le type n'est pas celui par défaut
                var TYPES_LABEL = ['Corner', 'Travel retail'],
                    label = TYPES_LABEL[type - 1] + (plural ? 's' : '');
                typeName += ' ' + app.t(label, 'StoreType');
            }
            return typeName;
        },
        getFooterSeo: function () {
            return this.get('footer_seo') || this.get('description_seo') || '';
        },
        getTypeId: function () {
            var type = 'store',
                type_shop = this.get('type_shop');
            switch (type_shop) {
                case 1:
                    type = 'corner';
                    break;
                case 2:
                    type = 'travel-retail';
                    break;
            }
            return type;
        },
        getTypeDiscoverLabel: function () {
            var model = this,
                label = 'Découvrir ';
            switch (model.get('type_shop')) {
                case 2:
                    label += "l'offre travel retail"; //
                    break;
                case 1:
                    label += "l'offre corner";
                    break;
                default:
                    label += 'le shop';
            }
            return app.t(label, _TRANSLATION_CONTEXT_STORES_);
        },
        getServices: function () {
            // utilisé sur le template Boutique
            return app.getStoreServices().filterByType(this.get('type_shop'));
        },
        isSalesOnWeb: function () {
            // retourne true si la boutique est disponible
            // en fonction du mode de livraison
            var store = this,
                sale_on_web = store.get('sale_on_web');
            return sale_on_web;
        },
        isAvailable: function (VAE) {
            // retourne true si la boutique est disponible
            // en fonction du mode de livraison
            var isVAE = VAE == true,
                store = this,
                comming_soon = store.get('comming_soon'),
                active = store.get('active'),
                sale_on_web = store.get('sale_on_web'),
                acceptDeliveryMode = store.get(
                    'accept_' + (isVAE ? 'vae' : 'shipping')
                );
            return !comming_soon && active && sale_on_web && acceptDeliveryMode;
        },
        isVae: function () {
            return this.get('accept_vae');
        },
        getPhone: function () {
            return this.get('phone');
        },
        getPhonePricing: function () {
            return this.get('phone_pricing');
        },
        getLatitude: function () {
            return parseFloat(this.get('gmap_latitude'));
        },
        getLongitude: function () {
            return parseFloat(this.get('gmap_longitude'));
        },
        getLatLng: function () {
            return {
                lat: this.getLatitude(),
                lng: this.getLongitude(),
            };
        },
        getLngLat: function () {
            // alias for mapbox
            return [this.getLongitude(), this.getLatitude()];
        },
        isInternational: function () {
            return this.collection && this.collection.international;
        },
        getUrl: function () {
            var store = this;
            return store.isInternational()
                ? this.get('url') // boutiques des autres pays
                : UrlFactory.getUrl('store', {
                      store_rewrite: this.get('link_rewrite'),
                  }); // boutiques du pays
        },
        getAboutUrl: function () {
            // lien vers la page de la typologie de groupe concernée
            // bien créer des Widget Group
            // avec les identifiants "about_corners", "about_travel_retails" et "about_shops"
            var type_shop = this.get('type_shop'),
                group_slug =
                    'about_' +
                    (type_shop == 1
                        ? 'corners'
                        : type_shop == 2
                        ? 'travel_retails'
                        : 'shops'),
                widgetGroup = app.getWidgetGroup(group_slug);
            return widgetGroup ? widgetGroup.getUrl() : this.getUrl();
        },
        getMessages: function () {
            // retourne la collection des messages par shop, visible sur la page boutique
            var messageCollection = this.messages;
            if (!messageCollection) {
                messageCollection = new StoreMessageCollection(this.id);
            }
            return messageCollection;
        },
        requestDistance: function (force) {
            var model = this,
                distance,
                type = 'distance_actual',
                maps,
                latLng = app.get('latLng'),
                storeLatLng = model.getLatLng();
            //
            function computeDistance(latLng) {
                try {
                    maps = google.maps;
                    storeLatLng = new maps.LatLng(storeLatLng);
                    distance = maps.geometry.spherical.computeDistanceBetween(
                        storeLatLng,
                        latLng
                    );
                    model.set(type, distance);
                    return distance;
                } catch (err) {
                    // do nothing
                }
            }
            if (!model.get(type) || force) {
                if (latLng) {
                    return computeDistance(latLng);
                } else {
                    model.listenToOnce(app, 'geolocation', function (location) {
                        computeDistance(location.latLng);
                    });
                    app.requestGeolocation();
                }
            }
            return model.get(type);
        },
        hasDistance: function (type) {
            type = !type ? '_actual' : type; // gère 2 types de distances
            var model = this,
                distance = model.get('distance' + type);
            // une basée sur la recherche, l'autre sur la position actuelle
            if (!distance) {
                distance = this.requestDistance();
            }
            return distance ? true : false;
        },
        getDistance: function (type, fixed) {
            type = !type ? '_actual' : type; // gère 2 types de distances
            var distance = this.get('distance' + type);
            if (!distance) {
                distance = this.requestDistance();
            }
            return distance >= 0
                ? (distance / 1000).toFixed(fixed >= 0 ? fixed : 1)
                : false;
        },
        formatDistance: function () {
            var d = this.getDistance();
            return d ? d + ' km' : '';
        },
        getDistricts: function () {
            return this.get('districts') || [];
        },
        hasDistricts: function () {
            return this.getDistricts().length > 0;
        },
        isAllowjackpot: function () {
            return this.get('allow_use_jackpot');
        },
        getGMBUrl: function () {
            var google_cid = this.get('google_cid');
            return google_cid
                ? 'https://www.google.com/maps?cid=' + google_cid
                : '';
        },
        getAddress: function (n) {
            n = n ? n : '';
            return this.get('address' + n);
        },
        getCity: function () {
            return this.get('city');
        },
        getPostcodes: function () {
            return this.get('postcodes');
        },
        isPostcode: function (id_postcode) {
            var postcode = this.getPostcode();
            return !!postcode && postcode.id === id_postcode;
        },
        getDeliveryAreas: function () {
            return this.get('deliveryAreas');
        },
        getDeliveryAreasBbox: function () {
            return this.get('deliveryAreasBbox');
        },
        getPostcode: function () {
            return app.getPostcodeByValue(this.get('postcode'));
        },
        formatPostcode: function () {
            return this.get('postcode');
        },
        getModifiers: function () {
            return this.get('modifiers');
        },
        getAutocompletePattern: function () {
            var store = this,
                autocompletePatternAttr = 'autocompletePattern',
                pattern = store.get(autocompletePatternAttr);
            if (!pattern) {
                var patternArray = _([Simplification(store.getName())]);
                var postcodes = store.getPostcodes();
                // on ajoute les données code postal (ville et numéro)
                _(postcodes).each(function (id_postcode) {
                    var postcode = app.getPostcode(id_postcode);
                    if (postcode) {
                        // si postcode existe
                        var localities =
                            postcode.getLocalitySimplification(false);
                        patternArray = _(
                            patternArray.union(patternArray.union(localities), [
                                Simplification(postcode.getPostcode()),
                            ])
                        );
                    }
                });
                pattern = patternArray.join(' ');
                store.set(autocompletePatternAttr, pattern);
            }
            return pattern;
        },
        //
        formatAddress: function (withPostcode) {
            var store = this,
                a = store.getAddress(),
                c = store.getCity();
            return (
                a +
                ', ' +
                (withPostcode ? store.formatPostcode() : '') +
                ' ' +
                c
            );
        },
        // vérifie que le ou les postcode est associé à la boutique
        intersectsOneOfThosePostcodes: function (postcodes, datetime) {
            // permet d'utiliser la fonction avec un postcode unique ou un tableau
            if (!_.isArray(postcodes)) {
                postcodes = [postcodes];
            }
            //
            var store = this,
                intersection = _.intersection(postcodes, store.getPostcodes());
            if (intersection.length > 0) {
                // si des postcodes sont disponibles
                // on vérifie par rapport dans le créneau horaire
                var zones = store.getZonesDatetime(datetime);
                //
                // si il y a des créneaux horaires
                //
                var zonesPostcodes = _(zones).map(function (zone) {
                    var id_district = zone.id_district;
                    if (id_district) {
                        // si il y a des quartiers, on vérifie le code postal du quartier
                        //
                        var districtPostcode =
                            app.getPostcodeByDistrict(id_district);
                        //
                        if (districtPostcode) {
                            // si on a un postcode
                            return districtPostcode.id;
                        } else {
                            // cas théoriquement non souhaitable
                            // données à nettoyer
                            app.error('district sans postcode', {
                                id_district: id_district,
                                id_store: store.id,
                            });
                        }
                    } else {
                        return zone.id_postcode;
                    }
                });
                intersection = _.intersection(intersection, zonesPostcodes);
            }
            return intersection;
        },
        isDatetimeAm: function (isVAE, targetDatetime) {
            var periods = this.getTimePeriods(isVAE, targetDatetime);
            return moment(targetDatetime).diff(periods.am.end) < 0;
        },
        isPeriodAvailable: function (isVAE, period, targetDatetime) {
            var periodTime = this.getTimePeriods(isVAE, targetDatetime)[period];
            return !(periodTime.passed || periodTime.closed);
        },
        // retourne true si c'est la boutique favorite
        isLike: function () {
            return this.id == app.getCustomer().get('shopLike');
        },
        isComein: function () {
            return this.get('is_comein');
        },
        getBenefits: function (type) {
            var benefit = this.get('benefit'),
                benefits = benefit[type] || [];
            return _(
                _(benefits).map(function (id_benefit) {
                    return app.getBenefit(id_benefit);
                })
            );
        },
        isExceptionnalClosure: function () {
            var closure = this.get('closure');
            return closure && closure.closed;
        },
        getExceptionnalClosureMessage: function () {
            var closure = this.get('closure'),
                message = (closure && closure.message) || '';
            return message;
        },
        getNextOpening: function (type) {
            //type = _.isUndefined(type) ? 'fromNow':type;
            //
            var store = this,
                storeOpeningCache = store.get('storeOpeningCache'),
                storeOpening =
                    storeOpeningCache || store.findAvailableDatetime(true),
                openingValue,
                openingCode, // 1 signifie ouvert
                openingState;

            if (!storeOpeningCache) {
                // performance issue
                store.set('storeOpeningCache', storeOpening);
            }

            if (store.isExceptionnalClosure()) {
                openingCode = 3;
                openingValue = app.t(
                    'Exceptionnellement fermé',
                    _TRANSLATION_CONTEXT_STORES_
                );
                openingState = false;
            } else if (store.isInternational()) {
                openingCode = 2;
                openingValue = app.t(
                    'Boutique internationale',
                    _TRANSLATION_CONTEXT_STORES_
                );
                openingState = false;
            } else if (storeOpening.closed) {
                openingCode = 0;
                openingValue = t('Fermé', _TRANSLATION_CONTEXT_STORES_);
                openingState = false;
            } else if (storeOpening.opened) {
                openingCode = 1;
                openingValue = t('Ouvert', _TRANSLATION_CONTEXT_STORES_);
                openingState = true;
            } else {
                var time = '';
                openingState = storeOpening.closed !== true;
                openingCode = openingState ? 1 : 0;
                switch (type) {
                    case 'time':
                        time = moment(storeOpening.openDatetime).format('LLLL');
                    default:
                    case 'fromNow':
                        time = moment(storeOpening.openDatetime).fromNow();
                        break;
                }
                openingValue =
                    t('Ouvre', _TRANSLATION_CONTEXT_STORES_) + ' ' + time;
            }
            return type === 'boolean'
                ? openingState
                : type === 'code'
                ? openingCode
                : openingValue;
        },
        getOpeningHours: function () {
            var store = this,
                AM = 'am',
                PM = 'pm',
                TIME_FORMAT = 'LT',
                TIME_OPENING_PREFIX = 'time_opening_',
                TIME_CLOSING_PREFIX = 'time_closing_',
                IS_CLOSED_PREFIX = 'is_closed_',
                DEFAULT_DAY = '2000-01-01 ',
                opening_hours = _(store.get('opening_hours')).clone() || [],
                startOfWeek = moment().weekday(0).day(); // différence dans le 1er jour de la semaine
            // par defaut, le jour 0  est le dimanche. En france c’est le lundi

            // NE MARCHE PAS
            for (var d = 0; d < startOfWeek; d++) {
                opening_hours.push(opening_hours[0]);
                opening_hours.shift();
            }

            // formate l'affichage d'un temps, via moment.js
            function FormatTime(time) {
                return moment(DEFAULT_DAY + time).format(TIME_FORMAT);
            }

            // TODO Gérer le premier jour de la semaine en fonction de la locale
            function FormatPeriod(period, dayData) {
                var is_closed = dayData[IS_CLOSED_PREFIX + period] == '1',
                    from,
                    to,
                    label = app.t(
                        'fermé le ' + (period === AM ? 'matin' : 'soir'),
                        _TRANSLATION_CONTEXT_STORES_
                    );
                if (!is_closed) {
                    from = FormatTime(dayData[TIME_OPENING_PREFIX + period]);
                    to = FormatTime(dayData[TIME_CLOSING_PREFIX + period]);
                    label = from + ' - ' + to;
                }

                return { label: label };
            }

            // Gère l'affichage automatique pour le service continu
            function Continous(dayData) {
                var amClosed = dayData[IS_CLOSED_PREFIX + AM] == '1',
                    pmClosed = dayData[IS_CLOSED_PREFIX + PM] == '1',
                    isContinousClosed = amClosed && pmClosed,
                    isContinous =
                        dayData[TIME_CLOSING_PREFIX + AM] ===
                            dayData[TIME_OPENING_PREFIX + PM] ||
                        isContinousClosed;
                if (isContinousClosed) {
                    isContinous = {
                        label: app.t(
                            'fermé toute la journée',
                            _TRANSLATION_CONTEXT_STORES_
                        ),
                    };
                } else if (isContinous) {
                    var label,
                        from = FormatTime(dayData[TIME_OPENING_PREFIX + AM]),
                        to = FormatTime(dayData[TIME_CLOSING_PREFIX + PM]);
                    label = from + ' - ' + to;
                    isContinous = { label: label };
                }
                return isContinous;
            }

            return _(
                _(opening_hours).map(function (dayData, i) {
                    var dayFormated = _(dayData).clone(),
                        day = moment().weekday(i);
                    dayFormated.day = day.day();
                    dayFormated.today = day.day() == new Date().getDay();
                    dayFormated.dayLabel = day.format('dddd');
                    dayFormated.continous = Continous(dayData);
                    dayFormated.am = FormatPeriod(AM, dayData);
                    dayFormated.pm = FormatPeriod(PM, dayData);
                    return dayFormated;
                })
            );
        },
        getTimePeriods: function (isVAE, targetDatetime, forceDiffer) {
            var now,
                targetMoment,
                targetDay,
                targetAmPm,
                targetData,
                targetOpeningHour,
                times = this.get('time'),
                timesV = times[isVAE ? 'vae' : 'vad'],
                opening_hours = this.get('opening_hours'),
                opening_am,
                now_closing_am,
                closed_am,
                opening_pm,
                now_closing_pm,
                closed_pm,
                isNowAm,
                isNowPm,
                targetMomentDay; //1000 * 60 * 15; // + 45 minutes

            // default return, if store time is not fetched
            if (!times || !opening_hours) return;

            // par défaut la date cible est maintenant
            if (!targetDatetime) {
                targetDatetime = new Date();
            }
            targetDay = targetDatetime.getDay();
            targetOpeningHour = opening_hours[targetDay];

            targetMoment = moment(targetDatetime);
            targetMomentDay = targetMoment.format('YYYY/MM/DD ');

            // am
            opening_am = targetOpeningHour.time_opening_am;
            now_closing_am = PadSeconds(timesV['now'][targetDay].time_end_am);
            closed_am = targetOpeningHour.time_closed_am == '1';
            // pm
            opening_pm = targetOpeningHour.time_opening_pm;
            now_closing_pm = PadSeconds(timesV['now'][targetDay].time_end_pm);
            closed_pm = targetOpeningHour.time_closed_pm == '1';

            function isNowInPeriod(am) {
                //
                // est-ce que la date cible utilise maintenant ou différer
                //
                var openingTodayPeriod = moment(
                        am ? opening_am : opening_pm,
                        'HH:mm:ss'
                    ),
                    closingTodayPeriod = moment(
                        am ? now_closing_am : now_closing_pm,
                        'HH:mm:ss'
                    ),
                    closed = am ? closed_am : closed_pm;
                //

                //
                return (
                    openingTodayPeriod.isBefore(targetDatetime) &&
                    closingTodayPeriod.isAfter(targetDatetime) &&
                    !closed
                );
            }

            isNowAm = isNowInPeriod(true);
            isNowPm = isNowInPeriod(false);
            now = isNowAm || isNowPm;

            targetData =
                timesV[forceDiffer ? 'differ' : now ? 'now' : 'differ'][
                    targetDay
                ];

            var // AM
                am_deb_date = new Date(
                    targetMomentDay + PadSeconds(targetData.time_deb_am)
                ),
                am_end_date = new Date(
                    targetMomentDay + PadSeconds(targetData.time_end_am)
                ),
                am_now_closing_date = new Date(
                    targetMomentDay + PadSeconds(now_closing_am)
                ),
                am_open_date = new Date(
                    targetMomentDay + PadSeconds(opening_am)
                ),
                am_closed = targetData.is_closed_am == '1',
                // PM
                pm_deb_date = new Date(
                    targetMomentDay + PadSeconds(targetData.time_deb_pm)
                ),
                pm_end_date = new Date(
                    targetMomentDay + PadSeconds(targetData.time_end_pm)
                ),
                pm_now_closing_date = new Date(
                    targetMomentDay + PadSeconds(now_closing_pm)
                ),
                pm_open_date = new Date(
                    targetMomentDay + PadSeconds(opening_pm)
                ),
                pm_closed = targetData.is_closed_pm == '1';

            var periods = {
                am: {
                    closed: am_closed,
                    passed: isBeforeNow(am_end_date),
                    passedNow: isBeforeNow(am_now_closing_date),
                    deb: am_deb_date,
                    end: am_end_date,
                    closing: am_now_closing_date,
                    open: am_open_date,
                },
                pm: {
                    closed: pm_closed,
                    passed: isBeforeNow(pm_end_date),
                    passedNow: isBeforeNow(pm_now_closing_date),
                    deb: pm_deb_date,
                    end: pm_end_date,
                    closing: pm_now_closing_date,
                    open: pm_open_date,
                },
            };
            return periods;
        },
        findAvailableDatetime: function (isVAE, targetDatetime, r) {
            //
            // cherche la meilleure date disponible pour la boutique en cours
            //

            // si la date est passée on se calle sur maintenant
            if (moment(targetDatetime).diff() < 0) {
                targetDatetime = new Date();
            }

            var store_closed = {
                closed: true,
            };

            var store = this,
                targetMoment = moment(targetDatetime),
                openDatetime,
                debDatetime,
                periods,
                conversion,
                now = -1; // différé

            if (!store.get('active') || store.isInternational()) {
                return store_closed;
            }

            // on arrondit au supérieur la date de destination à 15 minutes
            targetMoment = targetMoment.second(0).ceil(15, 'minutes');
            targetDatetime = targetMoment.toDate();

            periods = store.getTimePeriods(isVAE, targetDatetime);

            function Recursion() {
                // TODO attention, risque de récursivité infinie, il faut investiguer sur ce c
                // essaie de trouver le prochain créneau, en ajoutant une heure
                if (r > 72) {
                    return false;
                }
                var nextAvailableDatetime = store.findAvailableDatetime(
                    isVAE,
                    new Date(targetDatetime.getTime() + 3600 * 1000),
                    r ? r + 1 : 1
                );
                if (nextAvailableDatetime.closed && r >= 72) {
                    return false;
                }
                if (nextAvailableDatetime.moment) {
                    conversion = nextAvailableDatetime.moment.toDate();
                    openDatetime = nextAvailableDatetime.openDatetime;
                }
            }

            function ValidateMinDifferDelay(date) {
                var mDate = moment(date);
                if (minDifferDelay() > mDate.diff()) {
                    var upDate = mDate.add(15, 'minutes').toDate();
                    date = ValidateMinDifferDelay(upDate);
                }
                return date;
            }

            if (!periods) {
                return store_closed;
            }
            if (
                !(
                    periods.am.closed ||
                    periods.am.passed ||
                    periods.am.passedNow
                ) &&
                targetMoment.diff(periods.am.end) <= 0
            ) {
                // si la boutique n'est pas fermée le midi,
                // et que la plage am est passée
                // et que l’horaire cible est avant la fin de l’ouverture

                debDatetime = periods.am.deb;
                openDatetime = periods.am.open;
                if (targetMoment.diff(debDatetime) <= 0) {
                    // si on est avant l'ouverture
                    conversion = ValidateMinDifferDelay(debDatetime);

                } else if (targetMoment.diff(periods.am.end) <= 0) {
                    //
                    conversion = moment
                        .max(targetMoment, moment(debDatetime))
                        .toDate();
                    conversion = targetDatetime;

                } else {

                }
            } else if (
                !(
                    periods.pm.closed ||
                    periods.pm.passed ||
                    periods.pm.passedNow
                )
            ) {

                debDatetime = periods.pm.deb;
                openDatetime = periods.pm.open;
                if (targetMoment.diff(debDatetime) <= 0) {
                    conversion = ValidateMinDifferDelay(debDatetime);

                } else if (targetMoment.isAfter(periods.pm.end)) {
                    // cas après 23h on essaie de passer au lendemain
                    if (Recursion() === false) {
                        return {
                            closed: true,
                        };
                    }

                } else {
                    conversion = moment
                        .max(targetMoment, moment(debDatetime))
                        .toDate();

                }
            } else {
                // cas ou la boutique est fermée toute la journée
                // on essaie le lendemain

                if (Recursion() === false) {
                    return store_closed;
                }
            }
            var momentConversion = moment(conversion);
            //
            if (momentConversion.diff() <= 60000 * 30) {
                now = 1;
            } else if (
                moment(new Date())
                    .floor(24, 'hours')
                    .diff(momentConversion.clone().floor(24, 'hours')) == 0
            ) {
                now = 0;
            }
            if (_.isUndefined(openDatetime)) {
                return store_closed;
            }
            return {
                closed: false,
                openDatetime: openDatetime,
                openMoment: moment(openDatetime),
                opened: moment().diff(openDatetime) > 0, // test si la boutique est actuellement ouverte
                moment: momentConversion,
                momentFormated: momentConversion.format('LLLL'),
                now: now,
                diff: momentConversion.diff(targetDatetime),
            };
        },
        getZonesDatetime: function (datetime) {
            // retourne l’ensemble des districts et postcodes déservis dans l'horaire et jour désiré
            if (_.isUndefined(datetime)) {
                datetime = new Date();
            }
            var store = this,
                from_to_exp = /^(.*)-(.*)$/,
                factorized_options = store.get('factorized_options') || [],
                startOfDay = moment(datetime).startOf('day'),
                startOfDayDate = startOfDay.format('YYYY-MM-DD '),
                minimum_shipping = factorized_options.minimum_shipping || 0,
                zones = [];
            _(factorized_options).each(function (weekDays, timesKey) {
                var match = from_to_exp.test(timesKey);
                if (!match) return;

                var e = from_to_exp.exec(timesKey),
                    from = moment(startOfDayDate + e[1]),
                    to = moment(startOfDayDate + e[2]);
                //
                if (from.isBefore(datetime) && to.isAfter(datetime)) {
                    // on fait une union car potentiellement, plusieurs crénaux horaires
                    // peuvent être valides
                    zones = _.union(zones, weekDays[datetime.getDay()]);
                }
            });
            //
            // cas de factorisation
            if (minimum_shipping) {
                var postcodes = store.getPostcodes();
                zones = _.map(postcodes, function (postcode) {
                    var o = { id_postcode: postcode };
                    if (minimum_shipping) {
                        o.minimum_shipping = minimum_shipping;
                    }
                    return o;
                });
            }

            return zones;
        },
        getMinimumShippingPrice: function (datetime, id_postcode, id_district) {
            //
            // retourne le prix minimum de livraison pour une date donnée
            //
            var store = this,
                factorized_options = store.get('factorized_options'),
                minimum_shipping = 0;

            if (factorized_options.minimum_shipping) {
                minimum_shipping = factorized_options.minimum_shipping;
            } else {
                var zones = store.getZonesDatetime(datetime);
                if (id_district) {
                    var district = _(zones).findWhere({
                        id_district: id_district,
                    });
                    if (district) {
                        minimum_shipping = district.minimum_shipping;
                    }
                } else if (id_postcode) {
                    var postcode = _(zones).findWhere({
                        id_postcode: id_postcode,
                    });
                    if (postcode) {
                        minimum_shipping = postcode.minimum_shipping;
                    }
                }
            }
            return parseFloat(minimum_shipping);
        },
        isAvailableNow: function (isVAE) {
            return this.findAvailableDatetime(isVAE).now == 1;
        },
        getPictureUrl: function (format) {
            // TODO lié à la demande SSRS17-8
            var model = this,
                url = false,
                pic = model.get('picture');
            if (!pic) return false;
            pic = pic[0];
            if (pic) {
                url = UrlFactory.getUrlPicture(
                    pic,
                    'store',
                    '1920x1080',
                    model.get('link_rewrite'),
                    'jpg'
                );
            } else {
                url = UrlFactory.getThemeUrl() + 'medias/img/stores-banner.jpg';
            }
            return url;
        },
        getPaymentMethods: function () {
            var store = this,
                paymentMethodCollection =
                    store.paymentMethodCollection ||
                    new PaymentMethodCollection();
            if (paymentMethodCollection.size() === 0) {
                var modifiers = store.getModifiers(),
                    paymentMethods =
                        modifiers && modifiers.payment_method
                            ? modifiers.payment_method
                            : [];
                paymentMethodCollection.reset(paymentMethods);
                paymentMethodCollection.forEach(function (paymenthMethod) {
                    var defaults = _.defaults(
                        paymenthMethod.toJSON(),
                        app.getPaymentMethod(paymenthMethod.id).toJSON()
                    );

                    paymenthMethod.set(defaults);
                });
                store.paymentMethodCollection = paymentMethodCollection;
            }
            return paymentMethodCollection;
        },
        getPaymentGroups: function () {
            var store = this,
                paymentGroupCollection = store.paymentGroupCollection;
            if (!paymentGroupCollection) {
                paymentGroupCollection = new PaymentGroupCollection();
                var globalPaymentGroupCollection = app.getPaymentGroups();
                var modifiers = store.getModifiers(),
                    paymentModesModifiers = _(
                        modifiers && modifiers.payment_modes
                            ? modifiers.payment_modes
                            : []
                    );
                //
                globalPaymentGroupCollection.each(function (
                    globalPaymentGroup
                ) {
                    var paymentGroup = new PaymentGroupModel(
                        _.defaults(
                            { vae: false, vad: false },
                            globalPaymentGroup.toJSON()
                        )
                    );
                    paymentGroupCollection.add(paymentGroup);
                });
                paymentModesModifiers.each(function (modifier) {
                    var id_payment_mode = modifier.id_payment_mode,
                        basePaymentMode = app.getPaymentMode(id_payment_mode),
                        paymentMode;
                    // on merge les params
                    _(modifier.params).defaults(
                        basePaymentMode ? basePaymentMode.get('params') : {}
                    );
                    paymentMode = new PaymentModeModel(
                        _.defaults(
                            modifier,
                            basePaymentMode ? basePaymentMode.toJSON() : {}
                        )
                    );
                    paymentGroupCollection.each(function (paymentGroup) {
                        if (
                            _.contains(
                                paymentGroup.get('payment_modes'),
                                id_payment_mode
                            )
                        ) {
                            paymentGroup.addPaymentMode(paymentMode);
                        }
                    });
                });
                if (paymentModesModifiers.size())
                    store.paymentGroupCollection = paymentGroupCollection;
            }
            return paymentGroupCollection;
        },

        getStockoutProduct: function () {
            var store = this,
                stockoutProductModel = store.stockoutProduct;
            if (!stockoutProductModel) {
                stockoutProductModel = new StockoutProductModel({
                    id_store: store.id,
                });
                store.stockoutProduct = stockoutProductModel;
            }
            return stockoutProductModel;
        },

        fetchStockoutProduct: function (done, fail) {
            var stockoutProductModel = this.getStockoutProduct();
            stockoutProductModel.once('sync', done).once('error', fail);
            stockoutProductModel.fetch();
            return stockoutProductModel;
        },

        getPaymentMode: function (id_payment_mode) {
            var paymentGroups = this.getPaymentGroups();
            return paymentGroups.getPaymentMode(id_payment_mode);
        },

        getPaymentModes: function () {
            var paymentGroupCollection = this.getPaymentGroups();
            return paymentGroupCollection.getPaymentModes();
        },

        getTimes: function (isVAE, targetDatetime, forceAm) {
            //
            // retourne les horaires de la boutique, en fonction de VAE, et de la date cible
            //
            var periodHours = this.getTimePeriods(isVAE, targetDatetime, true),
                isAm = _.isUndefined(forceAm)
                    ? this.isDatetimeAm(isVAE, targetDatetime)
                    : forceAm,
                amPm = isAm ? 'am' : 'pm',
                d = moment(targetDatetime),
                period = periodHours[amPm],
                debDate = period.deb,
                endDate = period.end,
                periodAvailable = !(period.closed || period.passed),
                now = moment(new Date()),
                h = new Date(debDate),
                hoursArray = [],
                nowExists = false;

            // délai maximum pour différer une commande : 30 minutes
            now.add(0, 'minutes');
            while (moment(endDate).diff(h) >= 0) {
                var nowDiff = now.diff(h),
                    momentH = moment(h),
                    isNow = nowDiff < 0 && nowDiff > -minDifferDelay(); //(!nowExists) &&
                nowExists |= isNow;
                hoursArray.push({
                    label: momentH.format('LT'),
                    h: momentH.hours(),
                    m: momentH.minutes(),
                    isAvailable: periodAvailable && nowDiff < 0,
                    isNow: isNow,
                    date: h,
                });
                h.setMinutes(h.getMinutes() + 15);
            }
            return hoursArray;
        },
        setDeliveryAreas: function () {
            var model = this;
            var deliveryAreasGeoJson = model.get('deliveryAreas');
            // cette fonction est gourmande en calcul, on met les données en cache.
            if (!deliveryAreasGeoJson) {
                var deliveryAreasBbox;
                var deliveryAreasPolygons = [];
                var indexed = {};

                // on utilise le panier comme référence temporelle.
                var zones = model.getZonesDatetime(app.getCart().getDatetime());

                _(zones).each(function (zone) {
                    var polygons = false,
                        obj,
                        id_obj = zone.id_district;
                    if (zone.id_district) {
                        obj = app.getDistrict(id_obj);
                        if (obj && obj.polygons) {
                            polygons = obj.polygons;
                        }
                    } else if ((id_obj = zone.id_postcode)) {
                        obj = app.getPostcode(id_obj);
                        if (obj) {
                            polygons = obj.getPolygons();
                        }
                    }
                    if (polygons) {
                        deliveryAreasPolygons.push([polygons]);
                    }
                });

                deliveryAreasGeoJson = model.parseLatLngPolygonsToGeoJson(
                    deliveryAreasPolygons
                );
                deliveryAreasBbox = model.getBoundingBox(deliveryAreasGeoJson);

                deliveryAreasGeoJson.features.forEach(function (item) {
                    indexed[model.keyFor(item)] = item;
                });

                var coords = Object.keys(indexed).map(function (k) {
                    return indexed[k];
                });

                deliveryAreasGeoJson.features = coords;

                model.set({
                    deliveryAreas: deliveryAreasGeoJson,
                    deliveryAreasBbox: deliveryAreasBbox,
                });
            }
            model.trigger('ready:deliveryAreas', model);
        },
        parseLatLngPolygonsToGeoJson: function (latLngPolygons) {
            var geoJson = {
                type: 'FeatureCollection',
                features: [],
            };
            _.each(latLngPolygons, function (a) {
                _.each(a, function (x) {
                    _.each(x, function (b) {
                        var geometry = {
                            type: 'Polygon',
                            coordinates: [[]],
                        };
                        _.each(b, function (c) {
                            geometry.coordinates[0].push([c.lng, c.lat]);
                        });
                        geoJson.features.push({
                            type: 'Feature',
                            geometry: geometry,
                        });
                    });
                });
            });
            return geoJson;
        },

        getBoundingBox: function (gj) {
            var coords, bbox;
            if (!gj.hasOwnProperty('type')) return;
            coords = this.getCoordinatesDump(gj);
            bbox = [
                Number.POSITIVE_INFINITY,
                Number.POSITIVE_INFINITY,
                Number.NEGATIVE_INFINITY,
                Number.NEGATIVE_INFINITY,
            ];
            return coords.reduce(function (prev, coord) {
                return [
                    Math.min(coord[0], prev[0]),
                    Math.min(coord[1], prev[1]),
                    Math.max(coord[0], prev[2]),
                    Math.max(coord[1], prev[3]),
                ];
            }, bbox);
        },
        getCoordinatesDump: function (gj) {
            var coords;
            var model = this,
                coordinates = gj.coordinates,
                geometries = gj.geometries,
                features = gj.features,
                geometry = gj.geometry,
                type = gj.type;
            if (type === 'Point') {
                coords = [coordinates];
            } else if (type === 'LineString' || type === 'MultiPoint') {
                coords = coordinates;
            } else if (type === 'Polygon' || type === 'MultiLineString') {
                coords = coordinates.reduce(function (dump, part) {
                    return dump.concat(part);
                }, []);
            } else if (type === 'MultiPolygon') {
                coords = coordinates.reduce(function (dump, poly) {
                    return dump.concat(
                        poly.reduce(function (points, part) {
                            return points.concat(part);
                        }, [])
                    );
                }, []);
            } else if (type == 'Feature') {
                coords = model.getCoordinatesDump(geometry);
            } else if (type == 'GeometryCollection') {
                coords = geometries.reduce(function (dump, g) {
                    return dump.concat(model.getCoordinatesDump(g));
                }, []);
            } else if (type === 'FeatureCollection') {
                coords = features.reduce(function (dump, f) {
                    return dump.concat(model.getCoordinatesDump(f));
                }, []);
            }
            return coords;
        },
        recursiveFix: function (coords) {
            var model = this;
            if (coords instanceof Array) {
                _.each(coords, function (coord, i) {
                    if (
                        coords[i] instanceof Array &&
                        coords[i].length > 0 &&
                        coords[i][0] instanceof Array
                    ) {
                        coords[i] = model.recursiveFix(coord);
                    } else if (i < coords.length - 1) {
                        while (
                            coords[i][0] == coords[i + 1][0] &&
                            coords[i][1] == coords[i + 1][1]
                        ) {
                        }
                    }
                });

                return coords;
            }
        },
        findDuplicates: function (coords) {
            var flattened = _.flatten(coords, true);
            var repeats = [];

            do {
                var point = flattened.shift();

                _.each(flattened, function (testPoint) {
                    if (testPoint[0] == point[0] && testPoint[1] == point[1]) {
                        repeats.push(point);
                    }
                });
            } while (flattened.length > 0);

            return repeats;
        },
        keyFor: function (item) {
            var coordinates = item.geometry.coordinates;
            return coordinates[0] + ':' + coordinates[1];
        },
        getCornerLandingLink: function () {
            return app.c('_CORNER_LANDING_LINK_');
        },
        getAvisVerifie: function () {
            var store = this,
                avisVerifie = store.avisVerifie;
            if (!avisVerifie) {
                avisVerifie = new StoreAvisVerifieModel({
                    id_store: store.id,
                });
                store.avisVerifie = avisVerifie;
            }
            return avisVerifie;
        },
        fetchAvisVerifie: function (done, fail) {
            var storeAvisVerifieModel = this.getAvisVerifie();
            storeAvisVerifieModel.once('sync', done).once('error', fail);
            storeAvisVerifieModel.fetch();
            return storeAvisVerifieModel;
        },
        lastAvisVerifie: function () {
            var avis = this.getAvisVerifie();
            if (avis) {
                return _(avis.getComments());
            }

            return _([]);
        },
        getAvisStates: function () {
            var avis = this.getAvisVerifie();
            if (avis) {
                return avis.getStates();
            }

            return {
                1: '0',
                2: '0',
                3: '0',
                4: '0',
                5: '0',
            };
        },
        getAvisCertificateUrl: function() {
            var avis = this.getAvisVerifie();
            if (avis) {
                return avis.getCertificateUrl();
            }

            return '';
        },
    };

    var StoreModel =
        ObjectModel.extend(LocalStorage).extend(StoreModelPrototype);

    return StoreModel;
});

